import { render, staticRenderFns } from "./ActButton.vue?vue&type=template&id=5126713d&scoped=true&"
import script from "./ActButton.vue?vue&type=script&lang=ts&"
export * from "./ActButton.vue?vue&type=script&lang=ts&"
import style0 from "./ActButton.vue?vue&type=style&index=0&id=5126713d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126713d",
  null
  
)

export default component.exports